export default __webpack_public_path__ + "static/media/maxine_detail5.c70546be.jpg";